import React from 'react';
import { makeStyles } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { closeSnackbar } from '../../redux/actions/snackbarAction';
import { CustomAlert, CustomSnackbar } from './style';
// import "./style";

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
}));

export default function SnackbarComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { open, type, msg, isMasterAction, duration } = useSelector(
    reducer => reducer.snackbarReducer
  );

  const handleClose = (event, reason) => {
    if (isMasterAction && !duration && reason === 'clickaway') {
      return;
    }
    dispatch(closeSnackbar());
  };

  const autoHideDuration = duration ?? (isMasterAction ? null : 4000);

  return (
    <div className={classes.root}>
      <CustomSnackbar
        open={open}
        autoHideDuration={autoHideDuration}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        onClose={handleClose}
        // className="snackbar_bg"
      >
        {
          <CustomAlert onClose={handleClose} severity={type} variant="filled">
            <strong>{msg}</strong>
            {type === 'success'}
          </CustomAlert>
        }
      </CustomSnackbar>
    </div>
  );
}
